/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  FETCH_ALGOS_REQUEST,
  FETCH_ALGOS_SUCCESS,
  FETCH_ALGOS_FAILURE,
  FETCH_ALGO_BY_ID_REQUEST,
  FETCH_ALGO_BY_ID_SUCCESS,
  FETCH_ALGO_BY_ID_FAILURE,
  FETCH_HEALTH_STATUS_SUCCESS,
  FETCH_ALGO_CONFIG_REQUEST,
  FETCH_ALGO_CONFIG_SUCCESS,
  FETCH_ALGO_CONFIG_FAILURE,
} from '../../constants/ActionTypes';
import { getHealthDataAlgo } from '../../utils';

const list = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_ALGOS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ALGOS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
        paging: action.data.paging,
      };
    case FETCH_ALGOS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };

    case FETCH_HEALTH_STATUS_SUCCESS:
      const healthData = getHealthDataAlgo(action.data);

      const { data = [] } = state.data || {};
      const filterData = data.map((d) => {
        const { status = 'UNKNOWN' } =
          healthData.find((hd) => hd.id === d._id) || {};

        d.algoAPI = status;
        return d;
      });

      state.data.data = filterData;
      return state;
    default:
      return state;
  }
};

const selected = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_ALGO_BY_ID_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ALGO_BY_ID_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_ALGO_BY_ID_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const config = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_ALGO_CONFIG_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ALGO_CONFIG_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_ALGO_CONFIG_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const algos = combineReducers({
  list,
  selected,
  config,
});

export default algos;
